<template>
	<button type="submit" class="btn btn-round btn-primary" :disabled="loading">
		<spinner v-if="loading" size="small"/>
		<slot v-else/>
	</button>
</template>

<script>
export default {
	props: [
		'loading'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/ButtonSubmit.vue